module.exports = __webpack_public_path__ + "img/A58A2212_min.cc14cad2.jpg";